import React from 'react';
import { AlertTriangleIcon, XIcon, MailIcon } from 'lucide-react';
const UnverifiedAccountModal = ({
  email,
  onVerify,
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fade-in" data-id="element-226">
      <div className="bg-white rounded-2xl p-7 max-w-md w-full shadow-2xl relative" data-id="element-227">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100" aria-label="Close" data-id="element-228">
          <XIcon size={20} data-id="element-229" />
        </button>

        <div className="flex items-center justify-center mb-6" data-id="element-230">
          <div className="relative" data-id="element-231">
            <div className="bg-yellow-100 p-4 rounded-full" data-id="element-232">
              <AlertTriangleIcon className="h-8 w-8 text-yellow-600" data-id="element-233" />
            </div>
            <div className="absolute -top-1 -right-1 bg-blue-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs" data-id="element-234">
              <MailIcon size={12} data-id="element-235" />
            </div>
          </div>
        </div>

        <h3 className="text-xl font-semibold text-gray-900 text-center mb-4" data-id="element-236">
          Unverified Account
        </h3>

        <div className="mb-6" data-id="element-237">
          <div className="bg-blue-50 p-4 rounded-xl border border-blue-200 mb-4 shadow-sm" data-id="element-238">
            <p className="text-gray-600 text-center" data-id="element-239">
              Your account with email{' '}
              <span className="font-medium text-blue-700" data-id="element-240">{email}</span> is
              registered but not yet verified.
            </p>
          </div>
          <p className="text-gray-600 text-center" data-id="element-241">
            To access your account, you need to verify your email address.
          </p>
        </div>

        <div className="space-y-3" data-id="element-242">
          <button type="button" onClick={onVerify} className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-sky-600 text-white font-medium rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all" data-id="element-243">
            Verify My Account
          </button>

          <button type="button" onClick={onClose} className="w-full py-3 px-4 bg-white text-gray-700 font-medium rounded-xl border border-gray-300 hover:bg-gray-50 transition-colors" data-id="element-244">
            Cancel
          </button>
        </div>
      </div>
    </div>;
};
export default UnverifiedAccountModal;